import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

import CommonImage from '@/components/CommonImage';
import Textarea from '@/components/Textarea';
import { getUserInfo } from '@/utils/Util';
import AiLoader from '@/components/AiLoader';
import { jutilsApi } from '@/lib/jutils/jutilsApi';

import { animateAnswer, formatSopResponse } from './utils/sopUtils';

const SopSidebar = ({ onClose }) => {
	const [question, setQuestion] = useState('');
	const [addQuestion, setAddQuestion] = useState(false);
	const [showDefaultSopLinks, setShowDefaultSopLinks] = useState(true);
	const [qaHistory, setQaHistory] = useState([]);
	const [showLoader, setShowLoader] = useState(false);
	const qaHistoryRef = useRef(null);

	const handleSearch = async () => {
		try {
			setShowDefaultSopLinks(false);
			setShowLoader(true);
			setQaHistory((prev) => [...prev, { question, answer: '', displayedAnswer: '', isLoading: true }]);
			setQuestion('');
			setAddQuestion(false);
			setTimeout(() => {
				if (qaHistoryRef.current) {
					qaHistoryRef.current.scrollTop = qaHistoryRef.current.scrollHeight;
				}
			}, 0);

			const requestBody = { question };
			const response = await jutilsApi.post('/sop/query', requestBody);
			if (response?.length > 0) {
				animateAnswer(response, setQaHistory);
			}
			setShowLoader(false);
		} catch {
			setShowLoader(false);
		}
	};

	const handleClose = () => {
		setQaHistory([]);
		onClose();
	};

	useEffect(() => {
		if (qaHistoryRef.current) {
			qaHistoryRef.current.scrollTop = qaHistoryRef.current.scrollHeight;
		}
	}, [qaHistory]);

	return (
		<div className="sop-sidebar">
			<div className="sop-sidebar-container">
				<div className="sop-sidebar-content">
					<div className="sop-sidebar-header px-3 py-12 border-bottom-solid">
						<div className="d-flex justify-content-between">
							<p className="semibold-14 reqular-14">SOP</p>
							<CommonImage
								src="/icons/close.svg"
								className="cursor-pointer"
								onClick={handleClose}
							/>
						</div>
					</div>
					<div className="sop-sidebar-body scroll-y-label py-3 px-4" ref={qaHistoryRef}>
						<div className="sop-sidebar-body-header">
							{showDefaultSopLinks ? (
								<div className="default-sop-links">
									<ul className="sop-links-list">
										<li className="regular-14 mb-1 text-underline">
											<Link
												to="https://nitexsol-my.sharepoint.com/:w:/g/personal/abrar_masum_nitex_com/EW8pcRBKHwBGhe1DxUnBaygBQltYuf5o1GvEqyiLeJSpGA?rtime=NEIeSfSj3Ug"
												target="_blank"
											>
												Material Team SOP
											</Link>
										</li>
										<li className="regular-14 mb-1 text-underline">
											<Link
												to="https://nitexsol-my.sharepoint.com/:w:/g/personal/abrar_masum_nitex_com/EcRIgJx50J1Hri2LPz3bd90BD4CBl0QDcVfLFTAzm633fA?rtime=cl0UCeSy3Ug"
												target="_blank"
											>
												Pick and Choose SOP
											</Link>
										</li>
									</ul>
								</div>
							) : (
								<div className="searched-results mt-3">
									<p
										className="hide-searched-results regular-14 mb-4 cursor-pointer"
										onClick={() => {
											setShowDefaultSopLinks(true);
										}}
									>
										Hide
										<CommonImage
											src="/icons/down-arrow-gray-dark-01.svg"
											className="cursor-pointer ml-1"
										/>
									</p>
									<div className="qa-history">
										{qaHistory.map((qa, index) => (
											<div key={index} className="qa-group">
												<div className="question-container">
													<p className="question regular-14 mb-3">{qa.question}</p>
												</div>
												<p className="answer regular-14 mb-1">
													<span
														dangerouslySetInnerHTML={{
															__html: formatSopResponse(qa.displayedAnswer)
														}}
													/>
													{qa.isLoading && (
														<span className="sop-sidebar-loader-inline"></span>
													)}
												</p>
											</div>
										))}
									</div>
								</div>
							)}
							{showLoader && <AiLoader />}
						</div>
					</div>
				</div>

				<div className="sop-sidebar-footer d-flex align-items-center flex-direction-column p-3 border-top-solid">
					<div className="w-100">
						<div className="d-flex gap-3">
							{getUserInfo()?.profilePicDocument?.docUrl && (
								<img
									src={getUserInfo()?.profilePicDocument?.docUrl}
									alt="profile"
									className="profile"
								/>
							)}
							<Textarea
								autoComplete="off"
								name="question"
								value={question}
								autoFocus
								onChange={(e) => setQuestion(e.target.value)}
								style={{
									overflow: 'hidden',
									height: `${addQuestion ? '42px' : '28px'}`
								}}
								onClick={() => setAddQuestion(true)}
								placeholder="Ask a question..."
							/>
						</div>
						{addQuestion && (
							<div className="d-flex justify-content-end align-items-center w-100 mt-3">
								<div className="more-btn option">
									<button
										className="button size32 outline mr-2 dropdown-toggle"
										type="button"
										id="menu1"
										onClick={() => {
											setQuestion('');
											setAddQuestion(false);
										}}
									>
										Cancel
									</button>
								</div>
								<button className="button size32" disabled={!question} onClick={handleSearch}>
									<span className="mobile-version-btn">Submit</span>
								</button>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default SopSidebar;
